import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';

const Footer = ({ onOpenContactForm }) => {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = ['process', 'pricing', 'benefits', 'testimonials', 'faq'];

  return (
    <footer data-testid="main-footer" className="bg-[#111827] text-white relative overflow-hidden">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-8 pt-16 pb-10 relative z-10">
        {/* Top row - Brand + CTA */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="text-2xl md:text-3xl font-black tracking-tighter uppercase block" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Trademark<span className="text-[#FF1010]">.</span>Agency
            </span>
            <p className="text-sm text-white/50 mt-2 max-w-md">
              Professional trademark registration and USPTO filing for businesses across the United States.
            </p>
          </div>
          <button onClick={onOpenContactForm} className="inline-flex items-center gap-2 bg-[#FF1010] hover:bg-[#CC0000] text-white font-bold text-sm px-6 py-3 uppercase tracking-wider transition-colors self-start md:self-auto">
            Get Started <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/10 mb-10" />

        {/* Middle row - Nav + Contact */}
        <div className="grid md:grid-cols-2 gap-10 mb-12">
          {/* Nav links - horizontal */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-widest text-white/30 mb-4">Quick Links</h4>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              {navLinks.map(id => (
                <button
                  key={id}
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollTo(id)}
                  className="text-sm text-white/60 hover:text-[#FF1010] transition-colors capitalize font-medium"
                >
                  {id}
                </button>
              ))}
            </div>
          </div>

          {/* Contact - horizontal */}
          <div>
            <h4 className="text-[10px] font-black uppercase tracking-widest text-white/30 mb-4">Contact</h4>
            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-x-8 gap-y-3">
              <a href="tel:+18001234567" className="flex items-center gap-2 text-sm text-white/70 hover:text-[#FF1010] transition-colors font-medium">
                <Phone className="w-3.5 h-3.5 text-[#FF1010]" />
                +1 (800) 123-4567
              </a>
              <a href="mailto:info@trademarkagencyusa.com" className="flex items-center gap-2 text-sm text-white/70 hover:text-[#FF1010] transition-colors font-medium">
                <Mail className="w-3.5 h-3.5 text-[#FF1010]" />
                info@trademarkagencyusa.com
              </a>
              <span className="flex items-center gap-2 text-sm text-white/70 font-medium">
                <MapPin className="w-3.5 h-3.5 text-[#FF1010] flex-shrink-0" />
                265 E River Park Cir Ste 110, Fresno, CA 93720
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/25">
            &copy; {currentYear} Trademark Agency USA. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs">
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-white/25 hover:text-[#FF1010] transition-colors font-medium">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" data-testid="footer-terms-link" className="text-white/25 hover:text-[#FF1010] transition-colors font-medium">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
